module.exports = __webpack_public_path__ + "img/yanshufgray.7461b3e2.svg";